<template>
  <auth-layout>
    <div class="mb-6">
      <div
        v-if="resent"
        class="bg-positive-100 py-2 px-4 mb-4 text-positive-900 border border-positive-900"
      >
        <p>A fresh verification link has been sent to your email address.</p>
      </div>
      <h2 class="xl:text-4xl xl:font-light text-2xl font-bold">
        Verify Your Email Address
      </h2>
      <p>Before proceeding, please check your email for a verification link.</p>
      <p>
        If you did not receive the email, please check your junk email and
        whitelist {{ $config.emails.senders }} before requesting another.
      </p>
    </div>

    <app-button
      type="button"
      class="mt-8 mb-4"
      :disabled="loading"
      @click="sendLink"
    >
      <span v-if="!loading">Resend</span>
      <span v-else>Resending...</span>
    </app-button>
  </auth-layout>
</template>

<script>
import { requestMixin } from "../mixins/request";

export default {
  name: "Verify",
  mixins: [requestMixin],
  data() {
    return {
      loading: false,
      resent: false
    };
  },
  created() {
    document.title = `Verify Your Email Address :: ${document.title}`;
  },
  methods: {
    sendLink() {
      this.loading = true;
      return axios
        .get(route("verification.resend"))
        .then(response => this.loginResponse(response))
        .catch(error => this.requestError(error))
        .then(() => (this.loading = false));
    },
    loginResponse() {
      this.resent = true;
    }
  }
};
</script>
